const state = () => ({
  maintenanceInfo: null
})

const getters = {
  // メンテナンスの情報を定期的に取得するかどうかを返す
  needPeriodicCheck(state) {
    if (!state.maintenanceInfo) return true
    return state.maintenanceInfo.needPeriodicCheck
  },
}

const mutations = {
  setMaintenanceInfo(state, maintenanceInfo) {
    state.maintenanceInfo = maintenanceInfo
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}